import { render, staticRenderFns } from "./fileUploadNote.vue?vue&type=template&id=ef8fc6ae&"
import script from "./fileUploadNote.vue?vue&type=script&lang=js&"
export * from "./fileUploadNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports